module.exports = __webpack_public_path__ + "static/media/plan-with-inserts-img.178bb981.svg";